import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { StatCard } from '../components/solar/StatCard';
import { ChartCardWithPagination } from '../components/solar/ChartCardWithPagination';
import { getOptions } from '../components/options/wattAmTagBellCurve';
import { data } from '../components/data/wattAmTagBellCurve';
import { wattAmTagBellCurve } from '../components/objects/wattAmTagBellCurve';
import { Line } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';

class WattAmTagBellCurveClass extends Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const nextYear = parseInt(nextProps.match.params.Year) || 0;
        const nextMonth = parseInt(nextProps.match.params.Month) || 0;
        const nextDay = parseInt(nextProps.match.params.Day) || 0;
        if (prevState.prevYear !== nextYear || prevState.prevMonth !== nextMonth || prevState.prevDay !== nextDay) {
            return { prevYear: nextYear, prevMonth: nextMonth, prevDay: nextDay, _fetchNeeded: true };
        }
        return null;
    }

    componentDidMount() {
        const today = new Date();
        const Year = parseInt(this.props.match.params.Year) || today.getFullYear();
        const Month = parseInt(this.props.match.params.Month) || today.getMonth() + 1;
        const Day = parseInt(this.props.match.params.Day) || today.getDate();

        this.setState({ prevYear: Year, prevMonth: Month, prevDay: Day }, () => {
            wattAmTagBellCurve.WattAmTagBellCurveClass.forceRefresh = true;
            wattAmTagBellCurve.WattAmTagBellCurveClass.url =
                wattAmTagBellCurve.WattAmTagBellCurveClass.defaultSegment + "/bellcurve/" + Year + "/" + Month + "/" + Day;

            for (var k in wattAmTagBellCurve) {
                this.props.request(wattAmTagBellCurve[k]);
            }
        });
    }

    componentDidUpdate() {
        if (this.state._fetchNeeded) {
            const today = new Date();
            const nextYear = parseInt(this.props.match.params.Year) || today.getFullYear();
            const nextMonth = parseInt(this.props.match.params.Month) || today.getMonth() + 1;
            const nextDay = parseInt(this.props.match.params.Day) || today.getDate();

            this.setState({ _fetchNeeded: false }, () => {
                wattAmTagBellCurve.WattAmTagBellCurveClass.forceRefresh = true;
                wattAmTagBellCurve.WattAmTagBellCurveClass.url =
                    wattAmTagBellCurve.WattAmTagBellCurveClass.defaultSegment + "/bellcurve/" + nextYear + "/" + nextMonth + "/" + nextDay;

                for (var k in wattAmTagBellCurve) {
                    this.props.request(wattAmTagBellCurve[k]);
                }
            });
        }
    }

    state = {};

    render() {
        return (
            <div>
                {renderUIKPIRow(this.props)}
                {renderUIDatePicker(this.props)}
                {renderUIGesamt(this.props)}
            </div>
        );
    }
}

const TAGE = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

function getDefaultDate() {
    const d = new Date();
    return { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
}

function getDateFromParams(props) {
    const today = new Date();
    return {
        year: parseInt(props.match.params.Year) || today.getFullYear(),
        month: parseInt(props.match.params.Month) || today.getMonth() + 1,
        day: parseInt(props.match.params.Day) || today.getDate()
    };
}

function computeKpi(tagesertrag) {
    if (!tagesertrag || tagesertrag.length === 0) {
        return { max: 0, min: 0, avg: 0, sum: 0 };
    }
    const watts = tagesertrag.map(v => Math.round(v));
    const max = Math.max(...watts);
    const min = Math.min(...watts);
    const sum = watts.reduce((a, b) => a + b, 0);
    const avg = Math.round(sum / watts.length);
    return { max, min, avg, sum };
}

function renderUIKPIRow(props) {
    let bellCurveUI = props.WattAmTagBellCurveUI || {};

    // BOTH isLoaded=true UND Daten vorhanden
    let hasData = Array.isArray(bellCurveUI.Datum) && bellCurveUI.Datum.length > 0;
    let loading = !props.isLoaded || !hasData;

    const { year, month, day } = getDateFromParams(props);
    const weekday = TAGE[new Date(year, month - 1, day).getDay()];
    const dateStr = `${day}.${month}.${year} (${weekday})`;

    // KPI-Berechnungen
    let maxVal = 0;
    let minVal = 0;
    let avgVal = 0;
    let sumVal = 0;

    if (hasData && Array.isArray(bellCurveUI.Tagesertrag)) {
        const stats = computeKpi(bellCurveUI.Tagesertrag);
        maxVal = stats.max;
        minVal = stats.min;
        avgVal = stats.avg;
        sumVal = stats.sum;
    }

    return (
        <div className="row mb-3">
            <div className="col-12">
                <h5>PV-Leistung Glockenkurve — {dateStr}</h5>
            </div>
            <div className="col-6 col-md-3">
                <StatCard label={`Spitze · ${weekday}`} value={maxVal} unit="W" isLoading={loading} />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Minimum" value={minVal} unit="W" isLoading={loading} />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Durchschnitt" value={avgVal} unit="W" isLoading={loading} />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Stundensumme" value={sumVal.toLocaleString('de-DE')} unit="Wh" isLoading={loading} />
            </div>
        </div>
    );
}

function renderUIDatePicker(props) {
    const { year, month, day } = getDateFromParams(props);
    const dateValue = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

    return (
        <div className="bellcurve-date-picker-row mb-3">
            <label className="bellcurve-date-picker-label">
                <i className="bi bi-calendar-event" />
                &nbsp;Tag waehlen:
                <input
                    type="date"
                    className="bellcurve-date-input"
                    defaultValue={dateValue}
                    onChange={(e) => {
                        if (e.target.value) {
                            const parts = e.target.value.split('-');
                            props.history.push(
                                '/bellcurve/' + parts[0] + '/' + parts[1] + '/' + parts[2]
                            );
                        }
                    }}
                />
            </label>
        </div>
    );
}

function renderUIGesamt(props) {
    let bellCurveUI = props.WattAmTagBellCurveUI || {};

    // Loading: BOTH isLoaded=true UND Daten vorhanden
    let hasData = Array.isArray(bellCurveUI.Datum) && bellCurveUI.Datum.length > 0;
    let loading = !props.isLoaded || !hasData;

    // default chart data to avoid rendering undefined
    let chartData = { labels: [''], datasets: [{ data: [0] }] };

    if (hasData) {
        const tagesertrag = bellCurveUI.Tagesertrag;
        chartData = {
            labels: bellCurveUI.Datum,
            datasets: [
                { ...data.datasets[0], data: tagesertrag }
            ]
        };
    }

    return (
        <ChartCardWithPagination
            routeSegment={'bellcurve'}
            onlyYear={false}
            includeDay={true}
            match={props.match}
            history={props.history}
            loading={loading}>
            <Card className="chart-card">
                <Card.Body>
                    <Line data={chartData} options={{ ...getOptions(), animation: false }} />
                </Card.Body>
            </Card>
        </ChartCardWithPagination>
    );
}

export default connect(
    state => state.wattAmTagBellCurveReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(WattAmTagBellCurveClass);
